import React from 'react';
import { Col, Row } from 'antd';
import ServiceAnalytics from './ServiceAnalytics';
import HeadlineStats from './HeadlineStats';
import OperationMetrics from './OperationMetrics';
import AverageRouteMetrics from './AverageRouteMetrics';
import RoutePerformanceOverview from './RoutePerformanceOverview';
import { getSummeryMetrics } from '../../Utils/Summary.utils';
import type { SummeryProp } from '../../Types/Summary.types';

const Summery = ({ data, locations, routeOverviewMetrics, vehicleServiceKpi, routes }: SummeryProp): JSX.Element => {
  const metrics = getSummeryMetrics(data, locations, routes);

  return (
    <Row>
      <HeadlineStats
        numberOfRoutes={locations.number_of_routes}
        numberOfLocations={locations.number_of_locations}
        fuelSaving={data.fuel_saving}
        routeAdherence={metrics.routeAdherence}
      />

      <OperationMetrics
        totalDistance={data.total_distance}
        distanceSaved={data.distance_saved}
        distanceOptimizationPercent={metrics.distanceOptimizationPercent}
        fuelConsumption={data.fuel_consumption}
        fuelSaving={data.fuel_saving}
        fuelEfficiencyPercent={metrics.fuelEfficiencyPercent}
        totalOptimumCapacity={metrics.totalOptimumCapacity}
        totalUtilizedCapacity={metrics.totalUtilizedCapacity}
        capacityOptimizationPercent={metrics.capacityOptimizationPercent}
      />

      <AverageRouteMetrics
        avgLocPerRoute={metrics.avgLocPerRoute}
        avgDisPerRoute={metrics.avgDisPerRoute}
        avgDisBetweenLocs={metrics.avgDisBetweenLocs}
      />

      <Col span={24} className="pd-half-rem">
        <ServiceAnalytics kpi={vehicleServiceKpi} />
      </Col>

      <RoutePerformanceOverview
        routeOverviewMetrics={routeOverviewMetrics}
        totalActualDistance={data.total_actual_distance}
        routes={routes}
      />
    </Row>
  );
};

export default Summery;
